<template>
  <div class="queue-popup-wrap">
    <div class="popup-body" v-if="userInfo.fpid && popupList.length" v-show="showPopup">
      <template v-for="(item, index) in popupList">
        <component
          :key="item.name"
          v-if="item.name"
          v-show="index === 0 && showPopup"
          :is="item.name"
          :is-show="index === 0 && showPopup"
          :options="item.options || {}"
          @closed="showNext"
          @delPopup="delPopup"
        ></component>
      </template>
    </div>
  </div>
</template>

<script>
import PopupAntiLoss from '../popup/PopupAntiLoss.vue'
import BindAccount from './BindAccount.vue'
import InstallPWA from './InstallPWA.vue'
import ArrivalPanel from './ArrivalPanel.vue'
import { mapState } from 'vuex'
export default {
  name: 'QueuePopup',
  components: { BindAccount, InstallPWA, PopupAntiLoss, ArrivalPanel },
  data () {
    return {
      showPopup: false,
      popupList: [
        // { name: 'ArrivalPanel', options: { type: 'bind' } },
        { name: 'InstallPWA' },
        { name: 'BindAccount' },
        { name: 'PopupAntiLoss' }
      ],
      // 15s 后弹窗
      timer: null
    }
  },
  created () {
    this.$bus.$on('bind-checkout-old-account', () => {
      this.delPopup('BindAccount')
    })
    this.timer = setTimeout(() => {
      this.showPopup = true
    }, 10000)
  },
  computed: {
    ...mapState({
      userInfo: 'userInfo'
    })
  },
  methods: {
    // 显示下一个弹窗, 可指定生成下一个弹窗
    showNext (popupConf) {
      if (popupConf) {
        this.popupList.splice(1, 0, popupConf)
      }
      if (this.popupList === 1) return
      this.$nextTick(() => { this.popupList.shift() })
    },
    // 删除指定 name 弹窗
    delPopup (name) {
      let index = -1
      for (let i = 0; i < this.popupList.length; i++) {
        if (this.popupList[i].name === name) {
          index = i
          break
        }
      }
      if (index > -1) {
        this.popupList.splice(index, 1)
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('bind-checkout-old-account')
    clearTimeout(this.timer)
    this.timer = null
  }
}
</script>

<style lang='scss' scoped >
.queue-popup-wrap {
  font-family: 'bbsk';
}
.popup-body {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>
